import { DiagnosticData } from 'src/app/common/models/chatbotexpand.model';
import { ExcelDataModel, ChartDetails } from '../../../../common/models/chatbotexpand.model';
import { ExcelExportReport } from '../../../../common/models/excel-export-report.model';
import { ExportDataFormatterHelper } from './export-data-formatter.helper';
import * as _ from 'lodash';

export class ExportHandlerHelper {
  static handleExportClick(comp: any, block: any = null) {
      console.log("!!! EXPORT BUTTON CLICKED !!! block:", block != null);
    const target = block || comp;
    const mcode = comp.getMcode ? comp.getMcode(block) : (block && typeof block.mcode !== 'undefined' ? block.mcode : comp.mcode);

    if (mcode == 2 || mcode == 3) {
      const isolatedData = block ? comp.getOutputData(block) : comp.dataObject;
      const FilterValues = comp.getDistinctChildValues(isolatedData.Filter || []);
      const FilterData = comp.transformData(FilterValues);

      // Deep clone and normalize selectionInput ONLY for export to avoid breaking UI (NA values)
      console.log("--- EXCEL EXPORT LOG ---", "target.selectedWeight:", target.selectedWeight, "target.DefaultWeight:", target.DefaultWeight, "comp.selectedWeight:", comp.selectedWeight, "comp.DefaultWeight:", comp.DefaultWeight, "configService.weightLabel:", comp._configService?.weightLabel);
        const selectionInput = _.cloneDeep(isolatedData);
      if (selectionInput.flatData) {
        delete selectionInput.flatData;
      }

      // The backend model marks selectionInput.Filter (and the other selection arrays) as required.
      // When a block is loaded from chat history — e.g. navigating from a snapshot question to a
      // BA/CT question — the reconstructed dataObject can omit Filter, producing a 400
      // "The Filter field is required." Guarantee the required arrays are always present.
      if (!Array.isArray(selectionInput.Filter)) selectionInput.Filter = [];
      if (!Array.isArray(selectionInput.Row)) selectionInput.Row = [];
      if (!Array.isArray(selectionInput.Column)) selectionInput.Column = [];
      if (!Array.isArray(selectionInput.RowNesting)) selectionInput.RowNesting = [];
      if (!Array.isArray(selectionInput.ColNesting)) selectionInput.ColNesting = [];

      // When transpose is active, handleOutputdataObjectOnTransposeSelect has ALREADY physically
      // swapped Row↔Column in builtTableData/OutputdataObject. However, CrossTabOutPutData records
      // (rowChild/colChild) are always in the ORIGINAL orientation, and the backend ALSO swaps
      // Row↔Column when isTranspose=true. Sending already-swapped selectionInput with isTranspose=true
      // causes a double-swap → matching fails → empty Excel cells.
      if (target.isTranspose) {
        const tempRow = selectionInput.Row;
        selectionInput.Row = selectionInput.Column;
        selectionInput.Column = tempRow;
        const tempRowNesting = selectionInput.RowNesting;
        selectionInput.RowNesting = selectionInput.ColNesting;
        selectionInput.ColNesting = tempRowNesting;
      }

      const outputData = _.cloneDeep(isolatedData.flatData || target.CrossTabOutPutData || []);

      // Store matched items to assign final reconciled names after normalization
      const matchedRowItems = new Map<number, { parent: any, item: any }>();
      const matchedColItems = new Map<number, { parent: any, item: any }>();

      outputData.forEach((record: any, index: number) => {
        // 1. Row Matching: Find matching item in selectionInput.Row
        let matchedRow: { parent: any, item: any } | null = null;
        if (Array.isArray(selectionInput.Row)) {
          for (const parent of selectionInput.Row) {
            if (!parent.Data) continue;
            for (const item of parent.Data) {
              // Precise Match using BOTH Variable Code and Response Code if available
              let isCodeMatch = false;
              if (record.rowVariableCode && item.variablecode === record.rowVariableCode) {
                if (record.rowResponseCode && item.responsecode) {
                  isCodeMatch = item.responsecode === record.rowResponseCode;
                } else {
                  isCodeMatch = true;
                }
              }

              if (
                isCodeMatch ||
                (item.Child === record.rowChild) ||
                (record.rowChild && record.rowChild.endsWith('|' + item.Child)) ||
                (item.Child && item.Child.endsWith('|' + record.rowChild))
              ) {
                matchedRow = { parent, item };
                break;
              }
            }
            if (matchedRow) break;
          }
        }
        if (matchedRow) {
          matchedRowItems.set(index, matchedRow);
        } else {
          console.warn(`[EXPORT-DEBUG] WARNING: No matching row item found for record at index ${index}:`, {
            rowChild: record.rowChild,
            rowVariableCode: record.rowVariableCode,
            rowResponseCode: record.rowResponseCode
          });
        }

        // 2. Column Matching: Find matching item in selectionInput.Column
        let matchedCol: { parent: any, item: any } | null = null;
        if (Array.isArray(selectionInput.Column)) {
          for (const parent of selectionInput.Column) {
            if (!parent.Data) continue;
            for (const item of parent.Data) {
              // Precise Match using BOTH Variable Code and Response Code if available
              let isCodeMatch = false;
              if (record.colVariableCode && item.variablecode === record.colVariableCode) {
                if (record.colResponseCode && item.responsecode) {
                  isCodeMatch = item.responsecode === record.colResponseCode;
                } else {
                  isCodeMatch = true;
                }
              }

              if (
                isCodeMatch ||
                (item.Child === record.colChild) ||
                (record.colChild && record.colChild.endsWith('|' + item.Child)) ||
                (item.Child && item.Child.endsWith('|' + record.colChild))
              ) {
                matchedCol = { parent, item };
                break;
              }
            }
            if (matchedCol) break;
          }
        }
        if (matchedCol) {
          matchedColItems.set(index, matchedCol);
        } else {
          console.warn(`[EXPORT-DEBUG] WARNING: No matching col item found for record at index ${index}:`, {
            colChild: record.colChild,
            colVariableCode: record.colVariableCode,
            colResponseCode: record.colResponseCode
          });
        }
      });

      const normalizeSelection = (parentObj: any) => {
        if (!parentObj || !parentObj.Data) return;

        let isTimePeriodParent = parentObj.Parent === "Time Period";

        // Remove SortId and other extra properties from Parent level to match working payload
        if (parentObj.hasOwnProperty('SortId')) delete parentObj.SortId;
        if (parentObj.hasOwnProperty('isMultiPunch')) delete parentObj.isMultiPunch;
        if (parentObj.hasOwnProperty('MultiPunchNumber')) delete parentObj.MultiPunchNumber;
        if (parentObj.hasOwnProperty('brandanalysisCode')) delete parentObj.brandanalysisCode;
        if (parentObj.hasOwnProperty('is_entrypoint')) delete parentObj.is_entrypoint;

        parentObj.Data.forEach((s: any) => {
          const normalizeChild = (itemNode: any) => {
            if (isTimePeriodParent && itemNode.Child) {
              const parts = itemNode.Child.split('|');
              if (parts.length >= 2) {
                if (parts[0] === 'Time Period' && parts.length >= 3) {
                  parentObj.Parent = parts[1];
                  itemNode.Child = parts.slice(2).join('|');
                } else {
                  parentObj.Parent = parts[0];
                  itemNode.Child = parts.slice(1).join('|');
                }
              }
            }

            const pName = parentObj.Parent;
            if (itemNode.Child && itemNode.Child.startsWith(pName + '|')) {
              itemNode.Child = itemNode.Child.substring(pName.length + 1);
            }

            // Keep reference intact by mutating itemNode in place
            itemNode.variablecode = '';
            itemNode.responsecode = '';
            itemNode.NestedArray = itemNode.NestedArray || [];
            itemNode.isDerived = itemNode.isDerived || false;
            itemNode.customGroupId = itemNode.customGroupId || null;
            itemNode.isCustomGroup = itemNode.isCustomGroup || false;
            itemNode.CalculationType = itemNode.CalculationType || 'share';
            itemNode.isCustomCalculation = itemNode.isCustomCalculation || false;
            itemNode.CheckboxStatus = true;
            itemNode.isDerviedVariable = false;
            itemNode.sort_id = itemNode.sort_id || 1;

            // Prune any extra keys not allowed in correct working payload
            const allowedKeys = [
              'Child', 'variablecode', 'responsecode', 'NestedArray', 'isDerived',
              'customGroupId', 'isCustomGroup', 'CalculationType', 'isCustomCalculation',
              'CheckboxStatus', 'isDerviedVariable', 'sort_id'
            ];
            Object.keys(itemNode).forEach(key => {
              if (!allowedKeys.includes(key)) {
                delete itemNode[key];
              }
            });

            if (itemNode.NestedArray && itemNode.NestedArray.length > 0) {
              itemNode.NestedArray.forEach((n: any) => normalizeChild(n));
            }
          };
          normalizeChild(s);
        });
      };

      if (Array.isArray(selectionInput.Row)) {
        selectionInput.Row.forEach((r: any) => normalizeSelection(r));
      }
      if (Array.isArray(selectionInput.Column)) {
        selectionInput.Column.forEach((c: any) => normalizeSelection(c));
      }

      // Back-fill variablecode and responsecode from output records into selectionInput.
      // The AI-generated dataObject has empty codes, but the output API records carry real
      // rowVariableCode / rowResponseCode values. normalizeSelection() above cleared all codes
      // to '' — we now restore them so the backend Excel exporter can match rows/columns to
      // output values and populate the Excel cells correctly.
      outputData.forEach((record: any, index: number) => {
        const rowMatch = matchedRowItems.get(index);
        if (rowMatch && record.rowVariableCode && !rowMatch.item.variablecode) {
          rowMatch.item.variablecode = record.rowVariableCode;
          rowMatch.item.responsecode = record.rowResponseCode || '';
        }
        const colMatch = matchedColItems.get(index);
        if (colMatch && record.colVariableCode && !colMatch.item.variablecode) {
          colMatch.item.variablecode = record.colVariableCode;
          colMatch.item.responsecode = record.colResponseCode || '';
        }
      });
      // Re-match mean rows: they share rowChild with RespGrp rows so initial matching
      // points them at the wrong selectionInput item. Correct by CalculationType + name.
      outputData.forEach((record: any, index: number) => {
        if (record.CalculationType !== 'mean') return;
        const existing = matchedRowItems.get(index);
        if (!existing || existing.item.CalculationType === 'mean') return;
        const baseLabel = record.rowChild?.split('|').pop()?.toLowerCase() ?? '';
        if (Array.isArray(selectionInput.Row)) {
          for (const parent of selectionInput.Row) {
            if (!parent.Data) continue;
            for (const item of parent.Data) {
              if (item.CalculationType === 'mean' &&
                item.Child?.toLowerCase().includes(baseLabel)) {
                matchedRowItems.set(index, { parent, item });
                break;
              }
            }
            if (matchedRowItems.get(index)?.item.CalculationType === 'mean') break;
          }
        }
      });

      // Remove extra root keys not present in correct working payload
      if (selectionInput.hasOwnProperty('CustomGroup')) delete selectionInput.CustomGroup;
      if (selectionInput.hasOwnProperty('CustomCalculation')) delete selectionInput.CustomCalculation;

      const matchingSummary: any[] = [];

      // 3. Reconcile outputData rowChild and colChild using normalized selectionInput
      outputData.forEach((record: any, index: number) => {
        const rowMatch = matchedRowItems.get(index);
        let finalRowChild = record.rowChild;
        if (rowMatch) {
          const expectedRowChild = rowMatch.parent.Parent + '|' + rowMatch.item.Child;
          if (record.rowChild !== expectedRowChild) {
            record.rowChild = expectedRowChild;
          }
          finalRowChild = expectedRowChild;
        }

        const colMatch = matchedColItems.get(index);
        let finalColChild = record.colChild;
        if (colMatch) {
          const expectedColChild = colMatch.parent.Parent + '|' + colMatch.item.Child;
          if (record.colChild !== expectedColChild) {
            record.colChild = expectedColChild;
          }
          finalColChild = expectedColChild;
        }

        matchingSummary.push({
          Index: index,
          RowCode: record.rowVariableCode,
          RowResponse: record.rowResponseCode,
          ColCode: record.colVariableCode,
          ColResponse: record.colResponseCode,
          MatchedRowParent: rowMatch ? rowMatch.parent.Parent : 'FAILED',
          MatchedRowChild: rowMatch ? rowMatch.item.Child : 'FAILED',
          FinalRowKey: finalRowChild,
          MatchedColParent: colMatch ? colMatch.parent.Parent : 'FAILED',
          MatchedColChild: colMatch ? colMatch.item.Child : 'FAILED',
          FinalColKey: finalColChild
        });
      });

      console.group(`[EXPORT-DEBUG] Reconciled Mapping Summary Table (${outputData.length} records)`);
      console.table(matchingSummary);
      console.groupEnd();

      // Prefix selectionInput Child values with "Parent|" so they exactly match the rowChild/colChild
      // values in outputData. The backend Excel exporter does: x.rowChild == item.Child, and the
      // chatbot API returns rowChild/colChild in "Parent|Child" format (e.g. "Brand and Ad Awareness|Aided Brand Awareness"),
      // so selectionInput items must carry the same full path for the cell lookup to succeed.
      // The backend's BindRowHeaders/BindColumnsInSheet replaces "|" with ":" for display, so the
      // Excel headers will correctly render as "Brand and Ad Awareness : Aided Brand Awareness".
      if (Array.isArray(selectionInput.Row)) {
        selectionInput.Row.forEach((parent: any) => {
          if (parent.Data && parent.Parent) {
            parent.Data.forEach((item: any) => {
              if (item.Child && !item.Child.startsWith(parent.Parent + '|')) {
                item.Child = parent.Parent + '|' + item.Child;
              }
            });
          }
        });
      }
      if (Array.isArray(selectionInput.Column)) {
        selectionInput.Column.forEach((parent: any) => {
          if (parent.Data && parent.Parent) {
            parent.Data.forEach((item: any) => {
              if (item.Child && !item.Child.startsWith(parent.Parent + '|')) {
                item.Child = parent.Parent + '|' + item.Child;
              }
            });
          }
        });
      }
      const reconstructNesting = (items: any[] | undefined, axis: 'Col' | 'Row') => {
        if (!items || !Array.isArray(items)) return [];
        const seen = new Set<string>();
        const nestedItems: any[] = [];

        for (const parent of items) {
          for (const item of parent.Data ?? []) {
            for (const nested of item.NestedArray ?? []) {
              if (nested.Child && !seen.has(nested.Child)) {
                seen.add(nested.Child);
                nestedItems.push(_.cloneDeep(nested));
              }
            }
          }
        }

        if (!nestedItems.length) return [];
        const firstChild = nestedItems[0].Child ?? '';
        const nestParent = firstChild.includes('|') ? firstChild.split('|')[0] : 'Nesting';
        const result = [{ Parent: nestParent, Data: nestedItems }];
        return result;
      };

      if (!selectionInput.ColNesting?.length)
        selectionInput.ColNesting = reconstructNesting(selectionInput.Column, 'Col');

      if (!selectionInput.RowNesting?.length)
        selectionInput.RowNesting = reconstructNesting(selectionInput.Row, 'Row');
      let excelinputs: ExcelDataModel = {
        significance: target.DefaultSampleSize,
        isTranspose: target.isTranspose,
        baseType: target.baseType || false, // Match correct working payload
        confidenceLevel: target.DefaultSampleSize == 'None' ? 'None' : target.DefaultConfidenceLevel,
        output: JSON.stringify(outputData),
        studyName: comp.selected_study,
        clientName: comp.selected_client,
        filters: FilterData.join(','),
        nestingType: comp.isFilteringActive ? 'Filtering' : 'Profiling',
        isFiltering: comp.isFilteringActive,
        selectionInput: selectionInput,
        selectionSummary: (block?.selectionSummary || target.selectionSummary || comp.selectionSummary || block?.analyticalData?.selectionSummary || block?.analyticalData?.output_selection_data?.selectionSummary || '')
          .replace(/&nbsp;/g, ' ')
          .replace(/<[^>]*>/g, '')
          .replace(/\s+/g, ' ')
          .trim(),
        insightsVal: ExportHandlerHelper.normalizeInsightsVal(target.insightsVal || comp.insightsVal),
        failedComments: '',
        isTotal: target.isTotal || false,
        lowBase: Number(comp.LowBase) || 0,
        InsufficientBase: Number(comp.insufficientBase) || 0,
        threshold: Number(comp.threshold) || 0,
        selectedIndex: target.selectedIndex || '',
        selectedWeight: target.selectedWeight || '',
        DefaultWeight: target.DefaultWeight || comp._configService?.weightLabel || comp.DefaultWeight || '',
        isBrandAnalysis: mcode == 2,
        SignificanceVsReference: comp.replacePipe(target.SignificanceVsReference || ''),
        DataFormat: target.selectedDataFormat || 'Respondent Level',
        isSampleSizeBlock: true, // Matching working payload
        isWeightedSampleBlock: true, // Matching working payload
        query: block ? block.question : (comp.chatPreviewBlocks.length > 0 ? comp.chatPreviewBlocks[comp.chatPreviewBlocks.length - 1].question : comp.inputValue) || '',
        QuestionSummary: (block ? block.question : comp.currentQuestion) || '',
        AnswerSummary: (block ? (block.QuestionAnswer || block.response || '') : comp.currentAnswer) || '',
        is_sigtesting: target.is_sigtesting || comp.is_sigtesting || false,
        is_indexing: target.is_indexing || comp.is_indexing || false,
        totalValue: 'None',
        sortedRowOrder: [],
      };

      if (!comp.FooterNote) {
        if (block) block.isExcelExportLoading = true;
        else comp._loaderService.showLoader();

        comp.$unSubscribeSubmitData5 = comp.apiService.exportToExcelARK(excelinputs).subscribe(
          (excelBlob: Blob) => {
            let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
            let fileName = 'KantarXTab_' + excelinputs.clientName + '_' + excelinputs.studyName + '_' + datetimeFormat + '.xlsx';
            ExportHandlerHelper.downloadFile(excelBlob, fileName);

            if (block) block.isExcelExportLoading = false;
            else comp._loaderService.hideLoader();
          },
          (error: any) => {
            if (block) block.isExcelExportLoading = false;
            else comp._loaderService.hideLoader();
          }
        );
      } else {
        var istimePeriodWave = comp.isWaveTimePeriod();
        comp.$unSubscribeSubmitData5 = comp._exportDownloads.exportToExcelLargeSelection(excelinputs, istimePeriodWave).subscribe((result: any) => {
          if (result.HasValidData) {
            let ExportReport: ExcelExportReport = JSON.parse(result.Data);
          }
          comp.arktabaccess = false;
        });
      }
    } else if (mcode == 1) {
      ExportHandlerHelper.excelexportClicked(comp, block);
    }
  }

  static handlePPTExportClick(comp: any, block: any = null) {
    const target = block || comp;
    const mcode = comp.getMcode ? comp.getMcode(block) : (block && typeof block.mcode !== 'undefined' ? block.mcode : comp.mcode);
    if (mcode == 2 || mcode == 3) {
      // Check if bar chart has multiple categories with single series (brand analysis scenario)
      // In this case, use GroupBarChart path which handles dynamic data properly
      let useGroupBarChart = false;
      const barChartData = target.BarChart?.Data || comp.BarChart?.Data;
      if (target.isVerticalBarChartClick && barChartData?.length > 1) {
        const uniqueSeriesNames = [...new Set(barChartData.map((d: any) => d['Series Name']))];
        const uniqueCategoryNames = [...new Set(barChartData.map((d: any) => d['Category Name']))];
        // If single series but multiple categories, use GroupBarChart path
        if (uniqueSeriesNames.length === 1 && uniqueCategoryNames.length > 1) {
          useGroupBarChart = true;
        }
      }

      // Build SelectionSummary and guarantee a "Confidence Level:" segment is present.
      // The backend's BarChartExport.SetDataChartValue does:
      //   .FirstOrDefault(x => x.Contains("Confidence Level:")).Trim()
      // which throws NullReferenceException when the segment is absent (chatbot payloads omit it).
      const rawSelectionSummary = target.selectionSummary?.replace(/<[^>]*>/g, '') || comp.selectionSummary?.replace(/<[^>]*>/g, '') || '';
      const pptSelectionSummary = rawSelectionSummary.includes('Confidence Level:')
        ? rawSelectionSummary
        : rawSelectionSummary + (rawSelectionSummary ? ' || ' : '') + `Confidence Level: ${target.DefaultConfidenceLevel || comp.DefaultConfidenceLevel || 'None'}`;

      let pptinputs: ChartDetails = {
        selectedSignifcance: target.DefaultSampleSize == 'Pairwise' ? 'None' : target.DefaultSampleSize,
        ChartCategory: target.isLineChartClick
          ? 'LineOrTrendChart'
          : target.isVerticalBarChartClick || target.isVerticalGroupBarChartClick
            ? 'Bar'
            : 'StackedBar',
        DisplayName: target.isLineChartClick
          ? 'Line Chart'
          : (target.isVerticalBarChartClick && !useGroupBarChart)
            ? 'BarChart'
            : (target.isVerticalGroupBarChartClick || useGroupBarChart)
              ? 'GroupBarChart'
              : target.isVerticalStackChartClick && target.isTranspose
                ? 'StackedBar'
                : 'StackedColumn',
        ChartTitle: target.isLineChartClick
          ? 'Line Chart'
          : (target.isVerticalBarChartClick && !useGroupBarChart) && target.isTranspose
            ? 'horizontal bar chart'
            : (target.isVerticalBarChartClick && !useGroupBarChart) && !target.isTranspose
              ? 'vertical bar chart'
              : (target.isVerticalGroupBarChartClick || useGroupBarChart) && target.isTranspose
                ? 'Horizontal Cluster Bar Chart'
                : (target.isVerticalGroupBarChartClick || useGroupBarChart) && !target.isTranspose
                  ? 'Vertical Cluster Bar Chart'
                  : target.isVerticalStackChartClick && target.isTranspose
                    ? 'Horizontal Stacked Chart'
                    : 'Vertical Stacked Chart',
        ChartOutput: target.isLineChartClick
          ? JSON.stringify(target.LineChart)
          : target.isVerticalStackChartClick
            ? JSON.stringify(target.StackChart)
            : JSON.stringify(target.BarChart),
        isSolidPattern: false,
        chartId: target.isLineChartClick
          ? 1
          : target.isVerticalStackChartClick
            ? 2
            : (target.isVerticalBarChartClick || target.isVerticalGroupBarChartClick) && target.isTranspose
              ? 3
              : (target.isVerticalBarChartClick || target.isVerticalGroupBarChartClick) && !target.isTranspose
                ? 1
                : 0,
        Type: target.isTranspose ? 'Column' : 'Bar',
        insufficientBase: comp.insufficientBase,
        lowBaseValue: comp.LowBase,
        SelectionSummary: pptSelectionSummary,
        query: block ? block.question : (comp.chatPreviewBlocks.length > 0 ? comp.chatPreviewBlocks[comp.chatPreviewBlocks.length - 1].question : comp.inputValue),
        insightsVal: ExportHandlerHelper.normalizeInsightsVal(target.insightsVal || comp.getInsightsForBlock(target)),
        QuestionSummary: block ? block.question : comp.currentQuestion,
        AnswerSummary: block ? (block.QuestionAnswer || block.response || '') : comp.currentAnswer
      };

      if (block) block.isPPTExportLoading = true;
      else comp._loaderService.showLoader();

      comp.$unSubscribeSubmitData7 = comp.apiService.exportToPPT(pptinputs).subscribe(
        (pptBlob: Blob) => {
          if (block) block.isPPTExportLoading = false;
          else comp._loaderService.hideLoader();

          let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
          let fileName = 'KantarXTab_' + comp.selected_client + '_' + comp.selected_study + '_' + datetimeFormat + '.pptx';
          ExportHandlerHelper.downloadPPTFile(pptBlob, fileName);
        },
        (error: any) => {
          if (block) block.isPPTExportLoading = false;
          else comp._loaderService.hideLoader();
        }
      );
    } else {
      ExportHandlerHelper.editablePPTClicked(comp, comp.isTrendActive === true, block);
    }
  }
  static fixPayload(data: any) {
    const fix = (arr: any) => (typeof arr === 'string' ? JSON.parse(arr) : arr)?.map((w: any) => {
      const base = (w.response_payload?.inputWidgetDetails ?? w.response_payload_trendline?.inputWidgetDetails ?? [])
        .find((b: any) => b.widget_name === w.widget_name)?.customizationProperties;
      const p = typeof w.customizationProperties === 'string' ? JSON.parse(w.customizationProperties || '{}') : (w.customizationProperties || {});
      if (base && !p.darkTheme) w.customizationProperties = JSON.stringify({ ...JSON.parse(base), ...p });
      delete w.response_payload;
      delete w.response_payload_trendline;
      delete w.trendline_response;
      return w;
    });
    if (data?.outputArray) data.outputArray = JSON.stringify(fix(data.outputArray));
    if (data?.outputTrendArray) data.outputTrendArray = JSON.stringify(fix(data.outputTrendArray));
    return data;
  }

  static excelexportClicked(comp: any, block: any = null) {
    try {
      const rawPage0 = comp._configService.allPageOutputDataWithoutTrend?.[0];
      const allpageOutputDataWithoutTrend: any[] = rawPage0
        ? _.cloneDeep(rawPage0).sort((a: any, b: any) => a.previewChartPostion - b.previewChartPostion)
        : [];
      const widgetName = comp.filteredWidgetData?.widget_name;
      const filteredDataoutputArray = widgetName
        ? allpageOutputDataWithoutTrend.filter((item: any) => item.widget_name === widgetName)
        : allpageOutputDataWithoutTrend;
      const trendPage0: any[] = comp._configService.allPageOutputData?.[0] ?? [];
      const filteredDataoutputTrendArray = widgetName
        ? trendPage0.filter((item: any) => item.widget_name === widgetName)
        : trendPage0;
      const outputArray = filteredDataoutputArray.length > 0 ? filteredDataoutputArray : (comp.filteredWidgetData ? [comp.filteredWidgetData] : []);
      const outputTrendArray = filteredDataoutputTrendArray.length > 0 ? filteredDataoutputTrendArray : (comp.filteredWidgetData ? [comp.filteredWidgetData] : []);
      comp._configService.setDropdownValue('outputArray', JSON.stringify(outputArray));
      comp._configService.setDropdownValue('outputTrendArray', JSON.stringify(outputTrendArray));
      ExportHandlerHelper.handleExcelExportClick(comp, block);
    } catch (e) {
      console.error('[ExportHandler] excelexportClicked error:', e);
      if (block) block.isExcelExportLoading = false;
      else comp._loaderService?.hideLoader();
      comp.showToast?.('Error exporting Excel. Please try again.', 'error');
    }
  }

  static handleExcelExportClick(comp: any, block: any = null) {
      console.log("!!! SNAPSHOT EXCEL EXPORT BUTTON CLICKED !!! block:", block != null);
    let data = comp.Snapshotdataforexport;
        if (block) {
          data.DefaultWeight = block.DefaultWeight;
          data.selectedWeight = block.selectedWeight;
        } else {
          data.DefaultWeight = comp._configService?.weightLabel || comp.DefaultWeight;
        }

    if (!data.selectionSummary || data.selectionSummary.trim() === '') {
      const fallbackSummary = block?.selectionSummary || comp.selectionSummary || comp._configService?.selectionSummaryTextTitle;
      if (fallbackSummary) {
        data.selectionSummary = fallbackSummary;
      }
    }

    if (!data.compareAcross || data.compareAcross === 'None')
      data.compareAcross = comp.filteredWidgetData?.selectedcompareacrossOption || comp._configService.selectedSnapshotType || 'Single Brand';
    if (!data.studyName) data.studyName = comp.selected_study || '';
    if (!data.clientName) data.clientName = comp.selected_client || '';
    if (!data.snapshotName) data.snapshotName = comp.promptData?.Snapshot_Name || comp._configService.getDropdownValues().snapshotName || '';

    data = ExportHandlerHelper.fixPayload(data);
    // Ensure thresholds are loaded from IndexedDB cache via LoadRibbonData
    // This populates comp.insufficientBase and comp.lowBase from cached configuration
    if ((!comp.insufficientBase || !comp.lowBase) && comp.filteredlist) {
      comp.LoadRibbonData(comp.filteredlist);
    }

    // Set threshold values early from local properties (set by LoadRibbonData)
    if (comp.insufficientBase) {
      data.insufficientBase = Number(comp.insufficientBase) || 0;
      data.iSthreshold = Number(comp.insufficientBase) || 0;
    }
    if (comp.lowBase) {
      data.lowBase = Number(comp.lowBase) || 0;
      data.lBThreshold = Number(comp.lowBase) || 0;
    }

    if (data.compareAcross == 'Multiple Brands' || data.compareAcross == 'Multiple Markets') {
      data = ExportDataFormatterHelper.preapreexceldata(data);
    } else {
      data = ExportDataFormatterHelper.preapreexceldata1(data);
    }

    if (comp.significanceSelectedValue != 'None') {
      data.confidenceLevel = comp.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.userRole = "superadmin";
    data.custumview = true;
    data.isAggregatedData = comp._configService.isAggregatedData;
    data.isSemiAggregatedData = comp._configService.isSemiAggregatedData;
    data.isRespondentLevel = comp._configService.isRespondentLevel;
    data.compareacrossmultiplesection = data.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');
    if (block) block.isExcelExportLoading = true;
    else comp._loaderService.showLoader();
    const payload = { ...data };
    payload.DefaultWeight = (block ? block.DefaultWeight : null) || comp._configService?.weightLabel || comp.DefaultWeight;
      console.log("--- SNAPSHOT EXCEL EXPORT LOG ---", "block?.DefaultWeight:", block ? block.DefaultWeight : "NO BLOCK", "payload.DefaultWeight:", payload.DefaultWeight);
    payload.selectedWeight = (block ? block.selectedWeight : null) || comp.selectedWeight;
    payload.insightSelectionSummary = ExportHandlerHelper.normalizeInsightsVal(comp.insightsVal);
    payload.QuestionSummary = comp.currentQuestion;
    payload.AnswerSummary = comp.currentAnswer;

    if (typeof payload.outputArray !== 'string') {
      try {
        payload.outputArray = JSON.stringify(payload.outputArray ?? {});
      } catch (e) {
        payload.outputArray = '[]';
      }
    }

    if (typeof payload.outputTrendArray !== 'string') {
      try {
        payload.outputTrendArray = JSON.stringify(payload.outputTrendArray ?? []);
      } catch (e) {
        payload.outputTrendArray = '[]';
      }
    }

    comp.subscriptions.add(
      comp.apiService.exportToExcelARKSnapshot(payload).subscribe(
        (excelBlob: Blob) => {
          let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
          let fileName = 'Snapshot' + '_' + data.clientName + '_' + data.snapshotName + '_' + data.compareAcross + '_' + datetimeFormat + '.xlsx';
          ExportHandlerHelper.downloadFile(excelBlob, fileName);
          if (block) block.isExcelExportLoading = false;
          else comp._loaderService.hideLoader();
          comp.usageDataLog('Excel Export');
        },
        (error: any) => {
          if (block) block.isExcelExportLoading = false;
          else comp._loaderService.hideLoader();
        }
      )
    );
  }

  /**
   * Enriches outputTrendArray with multi-year trendline data for askme snapshot PPT exports.
   *
   * For FUNNEL CHART with Multiple Markets / Multiple Brands:
   *   - The backend loops `metric[0].metric_value` and produces one PPT slide per entry.
   *   - We collapse ALL metric entries into a SINGLE metric_value entry whose data array
   *     contains every metric × every year.
   *   - We encode the metric name in colChild as "Metric|{metricName}" so that the C#
   *     helper GetColChildPart(colChild, 1) resolves to the metric name as the series label,
   *     producing one combined slide with all metrics as distinct colored series.
   *
   * For all other chart types: each metric_value's data is replaced with the full multi-year
   * rows sourced from the embedded trendline_response.Data.
   */
  static enrichOutputTrendArrayWithTrendlineData(data: any): any {
    try {
      const outputTrendArray: any[] = typeof data.outputTrendArray === 'string'
        ? JSON.parse(data.outputTrendArray)
        : data.outputTrendArray;

      if (!Array.isArray(outputTrendArray) || outputTrendArray.length === 0) return data;

      const isFunnelMultiple =
        data.compareAcross === 'Multiple Brands' || data.compareAcross === 'Multiple Markets';

      const enriched = outputTrendArray.map((widget: any) => {
        const trendResponseRaw = widget?.trendline_response?.Data;
        if (!trendResponseRaw) return widget;

        let trendDataArray: any[];
        try {
          trendDataArray = typeof trendResponseRaw === 'string'
            ? JSON.parse(trendResponseRaw)
            : trendResponseRaw;
        } catch {
          return widget;
        }

        if (!Array.isArray(trendDataArray) || trendDataArray.length === 0) return widget;

        const widgetChartName = (widget?.widgetchart_name || '').toUpperCase();
        const isFunnelChart = widgetChartName.includes('FUNNEL');

        if (isFunnelChart && isFunnelMultiple) {
          // Collapse all metrics × all years into ONE metric_value entry.
          // colChild is set to "Metric|{metricName}" so the C# GetColChildPart(colChild, 1)
          // returns the metric name as the series label on the combined trend slide.
          const mergedData = trendDataArray.map((row: any) => ({
            data: row.answerWeightedShare !== undefined
              ? row.answerWeightedShare
              : row.totalWeightedShare,
            data2: null,
            lvl1Child: row.Level1ColChild || row.lvl1Child,
            colChild: `Metric|${row.rowChild}`,
            rowChild: row.rowChild,
            totalUnweightedBase: row.totalUnweightedBase,
            totalUnweightedShare: row.totalUnweightedShare,
            totalWeightedBase: row.totalWeightedBase,
            totalWeightedShare: row.totalWeightedShare,
            answerUnweightedBase: row.answerUnweightedBase,
            answerUnweightedShare: row.answerUnweightedShare,
            answerWeightedBase: row.answerWeightedBase,
            answerWeightedShare: row.answerWeightedShare,
            changeVsPY_Answer: row.changeVsPY_Answer ?? null,
            changeVsPY_Total: row.changeVsPY_Total ?? null,
            Level1ColResponseCode: row.Level1ColResponseCode,
            Level1NestColVariableCode: row.Level1NestColVariableCode,
            CalculationType: row.CalculationType || 'share',
            CalculationTypeIndex: 'index',
            baseValueforLSorIs: row.answerUnweightedBase || row.totalUnweightedBase || 0,
            changeVsPY: null,
            Significance_Value: null,
          }));

          const updatedWidget = { ...widget };
          if (Array.isArray(updatedWidget.metric) && updatedWidget.metric.length > 0) {
            updatedWidget.metric = [{
              ...updatedWidget.metric[0],
              metric_value: [{
                option: widget.widget_name || 'Trend',
                data: mergedData,
              }],
            }];
          }
          delete updatedWidget.trendline_response;
          return updatedWidget;
        }

        // Non-funnel or single brand: replace each metric_value's data with all time periods
        const groupedByMetric: { [key: string]: any[] } = {};
        for (const row of trendDataArray) {
          const key = row.rowChild;
          if (!key) continue;
          if (!groupedByMetric[key]) groupedByMetric[key] = [];
          groupedByMetric[key].push(row);
        }

        const updatedWidget = { ...widget };
        if (Array.isArray(updatedWidget.metric)) {
          updatedWidget.metric = updatedWidget.metric.map((m: any) => ({
            ...m,
            metric_value: Array.isArray(m.metric_value)
              ? m.metric_value.map((mv: any) => {
                const mvKey = mv.option || mv.rowChild || mv.metricName || '';
                // Try exact match first, then partial match (rowChild may contain extra prefix)
                let trendRows = groupedByMetric[mvKey];
                if (!trendRows || trendRows.length === 0) {
                  // Try matching where trendline rowChild ends with mvKey or mvKey ends with rowChild
                  const matchedKey = Object.keys(groupedByMetric).find(k =>
                    k === mvKey || k.endsWith(mvKey) || mvKey.endsWith(k) ||
                    (mvKey.includes('|') && k === mvKey.split('|').pop()!.trim()) ||
                    (k.includes('|') && mvKey === k.split('|').pop()!.trim())
                  );
                  if (matchedKey) trendRows = groupedByMetric[matchedKey];
                }
                if (!trendRows || trendRows.length === 0) return mv;
                const newData = trendRows.map((row: any) => ({
                  data: row.answerWeightedShare !== undefined
                    ? row.answerWeightedShare
                    : row.totalWeightedShare,
                  data2: null,
                  lvl1Child: row.Level1ColChild || row.lvl1Child,
                  colChild: row.colChild,
                  rowChild: row.rowChild,
                  totalUnweightedBase: row.totalUnweightedBase,
                  totalUnweightedShare: row.totalUnweightedShare,
                  totalWeightedBase: row.totalWeightedBase,
                  totalWeightedShare: row.totalWeightedShare,
                  answerUnweightedBase: row.answerUnweightedBase,
                  answerUnweightedShare: row.answerUnweightedShare,
                  answerWeightedBase: row.answerWeightedBase,
                  answerWeightedShare: row.answerWeightedShare,
                  changeVsPY_Answer: row.changeVsPY_Answer ?? null,
                  changeVsPY_Total: row.changeVsPY_Total ?? null,
                  Level1ColResponseCode: row.Level1ColResponseCode,
                  Level1NestColVariableCode: row.Level1NestColVariableCode,
                  CalculationType: row.CalculationType || 'share',
                  CalculationTypeIndex: 'index',
                  baseValueforLSorIs: row.answerUnweightedBase || row.totalUnweightedBase || 0,
                  changeVsPY: null,
                  Significance_Value: null,
                }));
                return { ...mv, data: newData };
              })
              : m.metric_value,
          }));
        }
        delete updatedWidget.trendline_response;
        return updatedWidget;
      });

      data.outputTrendArray = JSON.stringify(enriched);
    } catch (e) {
      console.error('[ExportHandler] Error enriching trendline data:', e);
    }
    return data;
  }

  static editablePPTClicked(comp: any, isTredendDataRequired: boolean = false, block: any = null) {
      console.log("!!! PPT EXPORT BUTTON CLICKED !!! block:", block != null);
    if (block) block.isPPTExportLoading = true;
    else comp._loaderService.showLoader();
    try {
      const blockWidget = block?.builtCustomData ?? null;
      const rawPage0 = blockWidget ? [blockWidget] : (comp._configService.allPageOutputDataWithoutTrend?.[0] ?? []);
      const allpageOutputDataWithoutTrend: any[] = blockWidget
        ? [blockWidget]
        : _.cloneDeep(rawPage0).sort((a: any, b: any) => a.previewChartPostion - b.previewChartPostion);
      const filteredWidget = blockWidget ?? comp.filteredWidgetData;
      const widgetName = filteredWidget?.widget_name;
      const filteredDataoutputArray = widgetName
        ? allpageOutputDataWithoutTrend.filter((item: any) => item.widget_name === widgetName)
        : allpageOutputDataWithoutTrend;
      const trendPage0: any[] = blockWidget ? [blockWidget] : (comp._configService.allPageOutputData?.[0] ?? []);
      const filteredDataoutputTrendArray = widgetName
        ? trendPage0.filter((item: any) => item.widget_name === widgetName)
        : trendPage0;
      let outputArray: any[] = [];
      if (blockWidget) {
        if (blockWidget.metric && Array.isArray(blockWidget.metric) && blockWidget.metric.length > 0) {
          outputArray = [blockWidget];
        } else if (blockWidget.outputArray) {
          try {
            const parsed = typeof blockWidget.outputArray === 'string' ? JSON.parse(blockWidget.outputArray) : blockWidget.outputArray;
            if (Array.isArray(parsed) && parsed.length > 0) outputArray = parsed;
          } catch (e) {}
        }
      }
      if (outputArray.length === 0) {
        outputArray = filteredDataoutputArray.length > 0 ? filteredDataoutputArray : (filteredWidget ? [filteredWidget] : []);
      }
      const outputTrend = filteredDataoutputTrendArray.length > 0 ? filteredDataoutputTrendArray : (filteredWidget ? [filteredWidget] : []);
      comp._configService.setDropdownValue('outputArray', JSON.stringify(outputArray));
      comp._configService.setDropdownValue('outputTrendArray', JSON.stringify(outputTrend));
      comp._configService.setDropdownValue('product', 'custom');
      comp._configService.getDropdownValues().staticText = comp._configService.staticText;
      let data = comp.Snapshotdataforexport;
        if (block) {
          data.DefaultWeight = block.DefaultWeight;
          data.selectedWeight = block.selectedWeight;
        } else {
          data.DefaultWeight = comp._configService?.weightLabel || comp.DefaultWeight;
        }

      if (!data.compareAcross || data.compareAcross === 'None')
        data.compareAcross = filteredWidget?.selectedcompareacrossOption || comp._configService.selectedSnapshotType || 'Single Brand';
      if (!data.studyName) data.studyName = comp.selected_study || '';
      if (!data.clientName) data.clientName = comp.selected_client || '';
      if (!data.snapshotName) data.snapshotName = comp.promptData?.Snapshot_Name || comp._configService.getDropdownValues().snapshotName || '';

      data = ExportHandlerHelper.enrichOutputTrendArrayWithTrendlineData(data);
      data = ExportHandlerHelper.fixPayload(data);

      data.isAggregatedData = comp._configService.isAggregatedData;
      data.isSemiAggregatedData = comp._configService.isSemiAggregatedData;
      data.isRespondentLevel = comp._configService.isRespondentLevel;

      let newCustomizationData: any;
      if (comp._configService.newCustomizationData != null) {
        newCustomizationData = comp._configService.newCustomizationData;
      }

      if (data.compareAcross == 'Multiple Brands' || data.compareAcross == 'Multiple Markets') {
        data = ExportDataFormatterHelper.preparePPTDataMultipleBrands(data, newCustomizationData);
      } else {
        data = ExportDataFormatterHelper.preparePPTDataSingleBrand(data, newCustomizationData);
      }

      const activeSig = block?.DefaultSampleSize || comp?.DefaultSampleSize || comp?.significanceSelectedValue || data?.significance || 'None';
      const activeSigVsRef = block?.SignificanceVsReference || comp?.SignificanceVsReference || data?.SignificanceVsReference || activeSig;
      const activeConf = block?.DefaultConfidenceLevel || comp?.displayConfidenceLevel || comp?.DefaultConfidenceLevel || data?.confidenceLevel || '95%';

      if (activeSig !== 'None' && activeSig !== '') {
        data.significance = activeSig;
        data.SignificanceVsReference = activeSigVsRef;
        data.confidenceLevel = activeConf;
      }

      data.colorpalate = JSON.stringify(comp.commonchartmodules?.color1 || []);
      data.globalColorMap = JSON.stringify(comp._configService?.getGlobalColorMap?.() || {});
      data.insightselectionSummary = ExportHandlerHelper.normalizeInsightsVal(comp.insightsVal);
      data.userInput = block?.question ?? comp.currentQuestion;
      data.QuestionSummary = block?.question ?? comp.currentQuestion;
      data.AnswerSummary = block?.QuestionAnswer ?? block?.response ?? comp.currentAnswer;

      console.log('[PPT-EXPORT-DEBUG] Final payload sent to callPptExportSnapshot:', {
        significance: data.significance,
        SignificanceVsReference: data.SignificanceVsReference,
        confidenceLevel: data.confidenceLevel,
        baseType: data.baseType,
        outputArrayParsed: (function() {
          try { return typeof data.outputArray === 'string' ? JSON.parse(data.outputArray) : data.outputArray; }
          catch(e) { return data.outputArray; }
        })(),
        fullDataObj: data
      });

      comp.subscriptions.add(
        comp.apiService.callPptExportSnapshot('', data, isTredendDataRequired).subscribe(
          (pptBlob: Blob) => {
            let fileName = comp._configService.getDropdownValues().clientName + '_' + comp._configService.getDropdownValues().snapshotName + '_' + ExportHandlerHelper.getCurrentDateTime() + '.pptx';
            ExportHandlerHelper.downloadPPTFile(pptBlob, fileName);
            comp.usageDataLog('Editable PPT Export');
            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            if (block) block.isPPTExportLoading = false;
            else comp._loaderService.hideLoader();
          },
          (error: any) => {
            console.error('Error exporting editable PPT:', error);
            comp.showToast('Error exporting PowerPoint. Please try again.', 'error');

            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            if (block) block.isPPTExportLoading = false;
            else comp._loaderService.hideLoader();
          }
        )
      );
    } catch (e) {
      console.error('[ExportHandler] editablePPTClicked error:', e);
      comp.showToast?.('Error exporting PowerPoint. Please try again.', 'error');
      comp._loaderService.hideLoader();
    }
  }

  static downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  static downloadPPTFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private static normalizeMarkdownTable(table: string): string {
    const lines = table.split('\n')
      .map((l: string) => l.trim())
      .filter((l: string) => l.length > 0 && !/^\|[\s\-|]+\|$/.test(l));
    if (lines.length === 0) return '';
    return [lines[0], '|||||', ...lines.slice(1)].join('\n');
  }

  static normalizeInsightsVal(insightsVal: any): string {
    let items: string[];
    try {
      items = typeof insightsVal === 'string' ? JSON.parse(insightsVal) : (Array.isArray(insightsVal) ? insightsVal : []);
    } catch {
      return JSON.stringify(insightsVal ?? []);
    }

    const result: string[] = [];
    for (const raw of items) {
      const item: string = String(raw).replace(/\\\\n/g, '\n').replace(/\\n/g, '\n');
      const tableIdx = item.search(/\n{2,}\s*\|/);
      if (tableIdx !== -1) {
        const textPart = item.slice(0, tableIdx).replace(/\n+$/, '').trim();
        const tablePart = item.slice(tableIdx).trim();
        if (textPart) result.push(textPart);
        if (tablePart) result.push(ExportHandlerHelper.normalizeMarkdownTable(tablePart));
      } else if (item.trimStart().startsWith('|')) {
        result.push(ExportHandlerHelper.normalizeMarkdownTable(item));
      } else {
        result.push(item.replace(/\n+$/, '').trim());
      }
    }

    return JSON.stringify(result.filter((s: string) => s.trim().length > 0));
  }

  static getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
    return formattedDateTime;
  }

  static exportToExcel(comp: any): void {
    comp.apiService.downloadDiagnosticsExcel().subscribe((blob: Blob) => {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '');
      const client = comp.selected_client && comp.selected_client.trim() !== '' ? comp.selected_client : '';
      const snapshot = comp.snapshotName && comp.snapshotName.trim() !== '' ? comp.snapshotName : 'Excel';
      const fileName = `${client}-${snapshot}-${formattedDate}.xlsx`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      comp.closeDropdown();
    });
  }

  static fetchDiagnostic(comp: any) {
    comp.inputValue = '';
    comp.apiService.getDiagonistics().subscribe((dt: any) => {
      try {
        const result = typeof dt === 'string' ? JSON.parse(dt) : dt;
        const data: Array<DiagnosticData> = JSON.parse(result.Data);
        comp.displayDiagnosticData(data);
      } catch (err) {
        console.error('Failed to load diagnostics data.', err, dt);
        alert('Failed to load diagnostics data.');
      }
    });
  }

  static viewOnline(comp: any): void {
    comp.isDiagnosticAnimating = true;
    const animationPromise = new Promise(resolve => setTimeout(resolve, 1000));
    const diagnosticPromise = Promise.resolve(comp.fetchDiagnostic()).catch(() => { });

    Promise.all([animationPromise, diagnosticPromise])
      .finally(() => {
        comp.isDiagnosticAnimating = false;
        comp._loaderService.hideLoader();
        comp.closeDropdown();
      });
  }
}
